module.exports = __webpack_public_path__ + "img/jc.f1ce16d9.jpg";